"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validator = exports.update = exports.set = exports.mergeLeft = exports.isUUID = exports.createTypes = exports.createSelector = exports.createReducer = exports.createActions = exports.assignLeft = exports.anyValue = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _fp = require("lodash/fp");
var _reselect = require("reselect");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const anyValue = () => true;
exports.anyValue = anyValue;
const assignLeft = exports.assignLeft = _fp.assign.convert({
  rearg: true
});
const mergeLeft = exports.mergeLeft = _fp.merge.convert({
  rearg: true
});
const set = exports.set = (0, _fp.setWith)(Object);
const update = exports.update = (0, _fp.updateWith)(Object);
const isUUID = v => /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(v);
exports.isUUID = isUUID;
const validator = function () {
  let requiredKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (object) {
    let invalidReturns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (typeof object !== 'object') {
      console.error("".concat(object, " is not an object"));
      return object;
    }
    const isValid = _lodash.default.reduce(requiredKeys, (acc, validator, key) => {
      if (!acc) {
        return false;
      }
      if (typeof validator !== 'function') {
        console.warn("Validator for \"".concat(key, "\" must be a function."));
        return acc;
      }
      const valid = validator(object[key]);
      if (!valid) {
        console.warn("Validator for \"".concat(key, "\" disagrees with value:"), object[key]);
      }
      return valid;
    }, true);
    if (invalidReturns) {
      return isValid && object;
    }
    return object;
  };
};

//  ██████╗ ███████╗██████╗ ██╗   ██╗ ██████╗███████╗██████╗ ███████╗
//  ██╔══██╗██╔════╝██╔══██╗██║   ██║██╔════╝██╔════╝██╔══██╗██╔════╝
//  ██████╔╝█████╗  ██║  ██║██║   ██║██║     █████╗  ██████╔╝███████╗
//  ██╔══██╗██╔══╝  ██║  ██║██║   ██║██║     ██╔══╝  ██╔══██╗╚════██║
//  ██║  ██║███████╗██████╔╝╚██████╔╝╚██████╗███████╗██║  ██║███████║
//  ╚═╝  ╚═╝╚══════╝╚═════╝  ╚═════╝  ╚═════╝╚══════╝╚═╝  ╚═╝╚══════╝
exports.validator = validator;
const createReducer = function () {
  let initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let handlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const reducerFunction = function () {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](action.payload)(state);
    }
    return state;
  };
  // Persistence is no more
  return reducerFunction;
};
exports.createReducer = createReducer;
const createTypes = (typeKeys, optionalNamespace) => {
  const typeValues = (0, _fp.isEmpty)(optionalNamespace) ? typeKeys : (0, _fp.map)(type => (0, _fp.join)('/', (0, _fp.concat)(optionalNamespace, type)), typeKeys);
  return (0, _fp.zipObject)(typeKeys, typeValues);
};
exports.createTypes = createTypes;
const createActions = typeMap => {
  const types = (0, _fp.keys)(typeMap);
  const typeValues = (0, _fp.values)(typeMap);
  const actionKeys = (0, _fp.map)(_fp.camelCase, types);
  const actionFunction = type => payload => ({
    type,
    payload
  });
  return (0, _fp.zipObject)(actionKeys, (0, _fp.map)(actionFunction, typeValues));
};

//  ███████╗███████╗██╗     ███████╗ ██████╗████████╗ ██████╗ ██████╗ ███████╗
//  ██╔════╝██╔════╝██║     ██╔════╝██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗██╔════╝
//  ███████╗█████╗  ██║     █████╗  ██║        ██║   ██║   ██║██████╔╝███████╗
//  ╚════██║██╔══╝  ██║     ██╔══╝  ██║        ██║   ██║   ██║██╔══██╗╚════██║
//  ███████║███████╗███████╗███████╗╚██████╗   ██║   ╚██████╔╝██║  ██║███████║
//  ╚══════╝╚══════╝╚══════╝╚══════╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝╚══════╝
exports.createActions = createActions;
const createSelector = exports.createSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, _lodash.default.isEqual);